import { BaseQueryDTO } from "./basequery-dto";

export class QueryPartMasterDTO extends BaseQueryDTO
{
    PartNumber: string;
    IsForSupplier: boolean;
}
